import { RestClient } from "../RestClient";

export type B110010FindResponse = {
  togetsuYm: string;
  togetsuYmF: string;
  getsujiYmd: string;
  getsujiYmdF: string;
  getsujiKbn: number;
  getsujiKbnHyouji: string;
};

// 検索メソッド
export const B110010Find = () => {
  return RestClient.get<B110010FindResponse>("b110010/find");
};

// 月次処理 予約登録
export const B110010Update = () => {
  return RestClient.put("b110010/update");
};
